import { render, staticRenderFns } from "./storeData5.vue?vue&type=template&id=1401fa64&scoped=true&"
import script from "./storeData5.vue?vue&type=script&lang=js&"
export * from "./storeData5.vue?vue&type=script&lang=js&"
import style0 from "./storeData5.vue?vue&type=style&index=0&id=1401fa64&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1401fa64",
  null
  
)

export default component.exports